import React from 'react';
import PropTypes from 'prop-types';
import baseTheme from 'oxyrion-ui/lib/Themes/baseTheme';
import { Loader, Button, Icon } from 'oxyrion-ui/lib';
import { rem } from 'polished';
import Img from 'react-image';
import styled from 'styled-components';
import { connect } from '../../Store';
import { Link } from 'react-router-dom';
import { __, formatPrice, formatVolume } from '../../Utils';
import {
  MobileWrapper,
  DesktopWrapper,
  MProductWrapper,
  MProductContentWrapper,
  MContentRow,
  MButtonRow,
  MLabel,
  MValue,
} from '../ReusableComponents/Table';
import SelfStateTextarea from '../SelfStateTextarea';
import QuantityPicker from '../QuantityPicker';
import DataTable from '../Table';
import placeholder from '../../Containers/ProductCatalog/Components/Gallery/placeholder-image.png';

const Wrapper = styled.div`
  box-shadow: 0 2px 4.55px 0.45px rgba(1, 1, 1, 0.07);
`;
const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  min-height: ${rem(32)}
  font-size: ${({ theme }) => theme.font.fontSizeS};
  align-items: center;
  display: flex;
  justify-content: center;
  background: ${props =>
    props.green ? ({ theme }) => theme.color.primary : 'unset'};
    color: ${props =>
      props.green ? ({ theme }) => theme.color.primaryBg : 'unset'};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: black;
  :hover {
    text-decoration: underline;
  }
  font-weight: bold;
`;
const ConfigurationWrapper = styled.div`
  font-size: ${rem(12)};
  width: 100%;
  text-align: end;
`;

const VouchersWrapper = styled.div`
  display: flex;
  // position: absolute;
  bottom: ${rem(5)};
  left: ${rem(7)};
`;

const Voucher = styled.div`
  border-radius: ${rem(4)};
  font-size: ${rem(10)};
  padding: ${rem(4)} ${rem(2)} ${rem(4)} ${rem(2)};
  margin-right: ${rem(4)};
  background: #70af00;
  position: relative;
`;

const AbsoluteDiscountWrapper = styled.div`
  position: absolute;
  font-weight: bold;
  cursor: pointer;
`;

const ProductNameWithDesc = styled(P)`
  flex-direction: column;
  justify-content: start;
  align-items: start;
  padding: ${rem(3)};
`;

const ProductNameWithDescGiftItem = styled(ProductNameWithDesc)`
  flex-direction: inherit;
  flex-direction: row;
  align-items: center;
`;

const DHeader = styled.div`
  outline: none;
  color: ${({ sorter, theme }) => sorter && theme.color.primary};
  font-size: ${({ theme }) => theme.font.fontSizeXS};
`;

const Delete = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(40)};
`;

const IconWrapper = styled.div`
  height: ${rem(32)};
  width: ${rem(32)};
  display: flex;
`;

const PercentIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: x-large;
  width: 30px;
  height: 30px;
  background: red;
  border-radius: 30px;
  font-size: 20px;
  color: white;
`;

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${rem(110)};
  margin-right: ${rem(12)};
`;

const StyledImg = styled(Img)`
  height: ${rem(80)};
  max-width: 100%;
`;

const StyledImgSmall = styled(Img)`
  height: ${rem(30)};
  max-width: 100%;
  margin-right: ${rem(8)};
  margin-left: ${rem(8)};
`;

const RelatedProductsWrapper = styled.div``;

const RelatedProductWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${rem(48)};
  margin-bottom: ${rem(12)};
`;

const GiftQuantityWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: #70af00;
  font-size: ${rem(12)};
  font-weight: bold;
  margin-right: ${rem(4)};
`;

const BonuseItem = styled.div`
  color: #70af00;
  font-size: ${rem(12)};
  font-weight: bold;
`;

const baseURL = process.env.REACT_APP_IMAGES_PREFIX;

class CartProductsTable extends React.PureComponent {
  createColumns() {
    return [
      {
        accessor: 'product_id',
        Header: () => <DHeader> {__('ČÍSLO')}</DHeader>,
        maxWidth: 200,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },
      {
        accessor: 'item_name',
        Header: () => <DHeader>{__('PRODUKT')}</DHeader>,
        Cell: props => {
          const { relatedProducts } = props.original;

          return (
            <ProductNameWithDesc>
              <AbsoluteDiscountWrapper>
                {props.original.price.amount_wd - props.original.price.amount >
                  0.01 && (
                  <IconWrapper title={__('Zľavaaa')}>
                    <PercentIcon>%</PercentIcon>
                  </IconWrapper>
                )}
              </AbsoluteDiscountWrapper>
              <StyledLink
                to={`catalog/list/${props.original.catalogProductId}`}
              >
                <ProductNameWithDescGiftItem>
                  <ImageWrapper>
                    <StyledImg
                      key={props.original.image_full_path}
                      src={[
                        `${baseURL}/images/500x0/${
                          props.original.image_full_path
                        }`,
                        placeholder,
                      ]}
                      loader={<Loader color="#70af00" />}
                    />
                  </ImageWrapper>

                  {props.original.payload &&
                    props.original.payload.campaignProduct && (
                      <IconWrapper>
                        <Icon
                          name="gift"
                          size="m"
                          color={baseTheme.color.primary}
                        />
                      </IconWrapper>
                    )}
                  {props.original.label === 'benefit_product' && (
                    <IconWrapper>
                      <Icon
                        name="gift"
                        size="m"
                        color={baseTheme.color.primary}
                      />
                    </IconWrapper>
                  )}
                  {props.original.label === 'discount' && (
                    <IconWrapper>
                      <PercentIcon>%</PercentIcon>
                    </IconWrapper>
                  )}

                  {`${props.value} ${
                    props.original.color_code
                      ? `(${__('Kód odtieňu: ')} ${props.original.color_code})`
                      : ''
                  }
                ${props.original.offer_id ? `- ${__('cenová ponuka')}` : ''}`}
                </ProductNameWithDescGiftItem>
              </StyledLink>

              {relatedProducts && relatedProducts.length > 0 && (
                <RelatedProductsWrapper>
                  {relatedProducts.map((r, index) => (
                    <RelatedProductWrapper>
                      <GiftQuantityWrapper>{r.quantity} x</GiftQuantityWrapper>
                      <IconWrapper title={__('Darček k nákupu')}>
                        <Icon
                          name="gift"
                          size="l"
                          color={baseTheme.color.primary}
                        />
                      </IconWrapper>
                      <ProductNameWithDescGiftItem>
                        <StyledImgSmall
                          key={r.image_full_path}
                          src={[
                            `${baseURL}/images/500x0/${r.image_full_path}`,
                            placeholder,
                          ]}
                          loader={<Loader color="#70af00" />}
                        />

                        <BonuseItem>{`${r.item_name} - ${formatPrice({
                          amount: r.price.amount_vat_excl,
                          currency: r.price.currency,
                        })}`}</BonuseItem>

                        <Delete
                          title={__('Nechcem darček')}
                          onClick={() =>
                            this.props.deleteRelatedProduct(props.index, index)
                          }
                        >
                          <Icon name="close" size="m" color="red" />
                        </Delete>
                      </ProductNameWithDescGiftItem>
                    </RelatedProductWrapper>
                  ))}
                </RelatedProductsWrapper>
              )}

              {this.props.vouchers && this.props.vouchers.length > 0 && (
                <VouchersWrapper>
                  {this.props.vouchers.map(v => (
                    <Voucher>{v}</Voucher>
                  ))}
                </VouchersWrapper>
              )}
              {this.props.readOnly &&
                this.renderInput(
                  props.original.description,
                  props.original.product_id,
                  props.original.color_code &&
                    props.original.color_code !== null
                    ? props.original.color_code
                    : undefined,
                )}
              {props.original.configuration_id && (
                <ConfigurationWrapper>
                  <span>{`${__('Súčasť konfigurácie spreju')}: `}</span>
                  <b>{props.original.configuration_id}</b>
                </ConfigurationWrapper>
              )}
            </ProductNameWithDesc>
          );
        },
        minWidth: 250,
      },
      {
        accessor: 'volume',
        Header: () => <DHeader>{__('OBJEM')}</DHeader>,
        Cell: props => {
          return (
            <P style={{ textAlign: 'end' }}>
              {props.value ? formatVolume(props.value) : 'N/A'}
            </P>
          );
        },
        maxWidth: 110,
      },
      {
        accessor: 'price',
        Header: () => <DHeader>{__('CENA ZA KUS BEZ DPH')}</DHeader>,
        Cell: props => {
          return (
            <P style={{ textAlign: 'end' }}>
              {formatPrice({
                amount: props.value.amount_vat_excl,
                currency: props.value.currency,
              })}
            </P>
          );
        },
        maxWidth: 1120,
      },
      {
        accessor: 'quantity',
        Cell: props => {
          return this.props.readOnly ||
            props.original.label === 'benefit_product' ||
            props.original.configuration_id ? (
            <P style={{ textAlign: 'center', justifyContent: 'center' }}>
              {props.value}
            </P>
          ) : (
            <QuantityPicker
              readOnly={
                this.props.productQuantityLoading === props.index ||
                (props.original.payload &&
                  props.original.payload.campaignProduct)
              }
              value={props.value}
              changeValue={e => this.props.quantityHandler(e, props.index)}
            />
          );
        },
        Header: () => <DHeader>{__('POČET KUSOV')}</DHeader>,
        maxWidth: 120,
      },
      {
        accessor: 'totalPrice',
        Header: () => <DHeader>{__('CENA SPOLU BEZ DPH')}</DHeader>,
        Cell: props => {
          return (
            <P
              style={{ fontWeight: 'bold' }}
              green={
                props.original.payload && props.original.payload.campaignProduct
              }
            >
              {this.props.productQuantityLoading === props.index ? (
                <Loader size="s" />
              ) : (
                <React.Fragment>
                  {formatPrice(props.value ? props.value : props.row.price)}
                </React.Fragment>
              )}
            </P>
          );
        },
      },
      {
        maxWidth: 50,
        Header: () => <DHeader />,
        Cell: props => {
          return this.props.readOnly ||
            (props.original.label &&
              props.original.label === 'benefit_product') ? (
            <div />
          ) : (
            <Delete onClick={() => this.props.deleteProduct(props.index)}>
              <Icon name="close" size="l" color="red" />
            </Delete>
          );
        },
      },
    ];
  }

  renderInput(description, productId, colorCode) {
    const { descriptionHandler } = this.props;
    return (
      <SelfStateTextarea
        key={productId}
        onValueChange={e => descriptionHandler(e, productId, colorCode)}
        placeholder={__('Popis k produktu - max 50 znakov')}
        value={description}
      />
    );
  }

  render() {
    const { products, readOnly, quantityHandler, deleteProduct } = this.props;

    products.forEach(item => {
      const price = {
        amount: item.quantity * item.price.amount_vat_excl,
        currency: item.price.currency,
      };
      item.totalPrice = price;
    });

    return (
      <Wrapper>
        <MobileWrapper>
          {products.map((product, index) => {
            return (
              <MProductWrapper
                green={product.payload && product.payload.campaignProduct}
                even={(index + 1) % 2 === 0}
                first={index === 0}
              >
                <MProductContentWrapper>
                  <MContentRow>
                    <MLabel>{__('Číslo:')}</MLabel>
                    <MValue>{product.product_id}</MValue>
                  </MContentRow>
                  <MContentRow>
                    <MLabel>{__('Produkt:')}</MLabel>
                    <MValue>
                      {product.item_name}
                      {product.payload && product.payload.campaignProduct && (
                        <IconWrapper>
                          <Icon
                            name="gift"
                            size="m"
                            color={baseTheme.color.primary}
                          />
                        </IconWrapper>
                      )}
                    </MValue>
                  </MContentRow>
                  <MContentRow>
                    <MLabel>{__('Objem:')}</MLabel>
                    <MValue>{product.volume}</MValue>
                  </MContentRow>
                  <MContentRow>
                    <MLabel>{__('Cena za ks:')}</MLabel>
                    <MValue>
                      {formatPrice({
                        amount: product.price.amount_vat_excl,
                        currency: product.price.currency,
                      })}
                    </MValue>
                  </MContentRow>
                  <MContentRow>
                    <MLabel>{__('Počet ks:')}</MLabel>
                    <MValue>
                      {readOnly ? (
                        product.quantity
                      ) : (
                        <QuantityPicker
                          value={product.quantity}
                          changeValue={e => quantityHandler(e, index)}
                          readOnly={
                            this.props.productQuantityLoading === index ||
                            (product.payload && product.payload.campaignProduct)
                          }
                        />
                      )}
                    </MValue>
                  </MContentRow>
                  <MContentRow>
                    <MLabel>{__('Spolu cena bez DPH:')}</MLabel>
                    <MValue>
                      {formatPrice(
                        product.totalPrice ? product.totalPrice : product.price,
                      )}
                    </MValue>
                  </MContentRow>
                  {!readOnly && (
                    <MButtonRow>
                      <Button danger onClick={() => deleteProduct(index)}>
                        {__('Odstrániť')}
                      </Button>
                    </MButtonRow>
                  )}
                </MProductContentWrapper>
              </MProductWrapper>
            );
          })}
        </MobileWrapper>
        <DesktopWrapper>
          <DataTable
            noDataText={__('Nenašli sa žiadne dáta')}
            minWidth={10}
            data={products}
            columns={this.createColumns()}
            pageSize={products && products.length ? products.length : 10}
            getTdProps={() => {
              return { style: { padding: 0, margin: 'auto' } };
            }}
            getTheadThProps={(state, rowInfo, column) => {
              if (column && column.sortable) {
                return {
                  onClick: e => {
                    this.handleSorter(e.target.innerHTML);
                  },
                };
              }
              return {};
            }}
            // className="-highlight -striped"
          />
        </DesktopWrapper>
      </Wrapper>
    );
  }
}

CartProductsTable.propTypes = {
  products: PropTypes.arrayOf(
    PropTypes.shape({
      product_code: PropTypes.string,
      item_name: PropTypes.string,
      volume: PropTypes.string,
      price: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.currency,
      }),
      quantity: PropTypes.number,
      payload: PropTypes.shape({
        campaignProduct: PropTypes.bool,
        relatedTo: PropTypes.string,
      }),
    }),
  ).isRequired,
  readOnly: PropTypes.bool,
  quantityHandler: PropTypes.func,
  deleteProduct: PropTypes.func,
  deleteRelatedProduct: PropTypes.func,
  productQuantityLoading: PropTypes.number,
  descriptionHandler: PropTypes.func,
  vouchers: PropTypes.arrayOf(PropTypes.string),
};

CartProductsTable.defaultProps = {
  readOnly: false,
  quantityHandler: () => {},
  deleteProduct: () => {},
  descriptionHandler: () => {},
  deleteRelatedProduct: () => {},
  vouchers: [],
  productQuantityLoading: -1,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(CartProductsTable);



// WEBPACK FOOTER //
// ./src/Components/CartProductsTable/index.jsx